import { styled } from '@mui/material/styles';

import { device } from 'src/constants/muiSize';

export const StyledButton = styled('button')(({ theme }) => ({
  border: 'none',

  background: 'transparent',

  width: 'fit-content',

  borderRadius: '1rem',

  color: theme.colors.base01,

  padding: '0',

  '&:hover': {
    opacity: '0.8',
  },

  cursor: 'pointer',
}));

export const ContentContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',

  padding: '1.2rem',

  columnGap: '0.6rem',

  [`@media ${device.laptop}`]: {
    padding: '0',
    columnGap: '0.2rem',
  },
});

export const ContentRightContainer = styled('div')({
  display: 'flex',
  justifyContent: 'left',
  alignItems: 'center',
});

export const ContentRightTextContainer = styled('div')(({ theme }) => ({
  color: theme.colors.base01,
}));

export const ContentImageContainer = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});
